import React, { memo, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forceCheck } from 'react-lazyload';

import './Slider.css';

const Slider = memo(
  ({
    currSlide,
    swiping,
    left,
    context,
    count,
    children,
    sliderWrapperClassName,
  }) => {
    useEffect(() => {
      forceCheck();
    }, [currSlide]);
    return (
      <div
        className={classNames('slider-wrapper', sliderWrapperClassName, {
          [`slider-wrapper-${context}`]: context,
        })}
      >
        <div
          id="slider"
          style={{
            transform: `translate3d(${left}px, 0px, 0px)`,
            width: `${count * 100}%`,
          }}
          className={`slider ${
            !swiping ? 'zoom-image-slider-animate-left' : ''
          }`}
        >
          {children}
        </div>
      </div>
    );
  }
);

Slider.propTypes = {
  currSlide: PropTypes.number.isRequired,
  swiping: PropTypes.bool.isRequired,
  left: PropTypes.number.isRequired,
  context: PropTypes.string,
  count: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  sliderWrapperClassName: PropTypes.string,
};

Slider.defaultProps = {
  context: '',
  sliderWrapperClassName: null,
};

export default Slider;
